import { useCurrentOrganizationBilling } from '@/hooks/useSwr';

import { ApprovalPlanType } from '../../types/billing.type';
import { hasValidApprovals } from '../../utils/helpers';

export const useShowApprovalPlanCard = ({
  planType,
  checkApproval = true,
}: {
  planType: ApprovalPlanType;
  checkApproval?: boolean;
}) => {
  const { data: currentOrganization } = useCurrentOrganizationBilling();

  const currentTier = currentOrganization?.current_plan?.tier;
  const upcomingTier = currentOrganization?.upcoming_plan?.tier;

  const approvals = hasValidApprovals(currentOrganization);

  return (
    currentTier === planType ||
    upcomingTier === planType ||
    (checkApproval && approvals[planType])
  );
};

export const useHasAnyApprovals = () => {
  const { data: currentOrganization } = useCurrentOrganizationBilling();
  const approvals = hasValidApprovals(currentOrganization);
  return Object.values(approvals).some((approval) => approval);
};
